import utils from '../utils/utils'
import { animate, cubicBezier, stagger } from 'animejs';
import globalVar from '../utils/globalVar'

class Nav {
  constructor() {
    let cache = {};
    let scrollPos = 0;
    let hasSticky = false;
    let inFooterZone = false;
    let navNavigating = false;
    let cachedFooterHeight = 0;
    let initFunc = () => {
      initCache();
      registerEvents();
      animeScroll();
      updateNavColor();
    }

    let initCache = () => {
      cache.header = document.querySelector('header');
      cache.mainNav = document.querySelector('.main_nav');
      cache.mainNavBg = cache.mainNav.querySelector('.bg');
      cache.nav = document.querySelector('.nav');
      cache.mainLinksBgContainer = document.querySelector('.nav_bg-container');
      cache.mainLinks = cache.nav.querySelectorAll('a');
      cache.mainLinkWrappers = cache.mainNav.querySelectorAll('.main-nav-link');
      cache.secLinks = cache.mainNav.querySelectorAll('.nav-sec a');

      cache.btnOpenMenu = document.querySelector('header .top_nav .btn_menu');
      cache.darkSections = document.querySelectorAll('section.bg-dark, section.bg-dark-blue');
      cache.navWhiteSections = document.querySelectorAll('section.nav-white');
      cache.navDarkSections = document.querySelectorAll('section.nav-dark');

      cache.pageWrapper = document.querySelector('.wrapper');
      cache.footer = document.querySelector('footer');
    };

    let registerEvents = () => {
      cachedFooterHeight = cache.footer.offsetHeight;
      cache.pageWrapper.style.marginBottom = cachedFooterHeight + 'px';
      cache.btnOpenMenu.addEventListener("click", openNav);
      window.addEventListener('scroll', animeScroll);
      window.addEventListener('scroll', updateNavColor);
      window.addEventListener('resize', () => {
        cachedFooterHeight = cache.footer.offsetHeight;
        cache.pageWrapper.style.marginBottom = cachedFooterHeight + 'px';
      });
    };

    let hoverHandlers = new Map();
    let leaveHandlers = new Map();

    let hoverLink = (link) => {
      if(globalVar.desktop.matches) {
        const color = link.getAttribute('data-color');
        cache.mainNav.classList.add(color);
        link.classList.add('hover');
        if(color === 'white' && !cache.header.classList.contains('nav_white')) {
          cache.header.classList.remove('nav_dark');
          cache.header.classList.add('nav_white');
        }
        const leaveHandler = () => outLink(link);
        leaveHandlers.set(link, leaveHandler);
        link.addEventListener("mouseleave", leaveHandler);

        const imgClass = link.getAttribute('data-img');
        const img = cache.mainLinksBgContainer.querySelector('.' + imgClass);
        
        animate(img, {
          opacity: 1,
          scale: 1,
          duration: 600,
          ease: cubicBezier(0.567, -0.013,0.493,0.98)
        });
      }
    };

    let outLink = (link) => {
      if (navNavigating) return;
      link.classList.remove('hover');
      const color = link.getAttribute('data-color');
      cache.mainNav.classList.remove(color);
      if(cache.header.classList.contains('nav_white')) {
        cache.header.classList.remove('nav_white');
        cache.header.classList.add('nav_dark');
      }
      const imgClass = link.getAttribute('data-img');
      const img = cache.mainLinksBgContainer.querySelector('.' + imgClass);
      
      animate(img, {
        opacity: 0,
        scale: 1.05,
        duration: 600,
        ease: cubicBezier(0.567, -0.013,0.493,0.98)
      });
    };

    let openNav = () => {
      cache.btnOpenMenu.removeEventListener("click", openNav);
      cache.mainNav.style.display="block";
      cache.header.classList.add('nav_open');
      if(cache.header.classList.contains('nav_white')) {
        cache.header.classList.toggle('nav_dark');
        cache.header.classList.toggle('nav_white');
      }
      if(cache.header.classList.contains('has-sticky')) {
        hasSticky = true;
        cache.header.classList.add('open_has-sticky');
      }
      window.removeEventListener('scroll', animeScroll);
      window.removeEventListener('scroll', updateNavColor);
      utils.disableScroll();
      setTimeout(() => {
        cache.mainNavBg.classList.remove('anime-init');
        animate(cache.mainLinkWrappers, {
          opacity: [0, 1],
          delay: stagger(100),
          duration: 800,
          ease: cubicBezier(0.567, -0.013,0.493,0.98),
        });
      }, 600);
      animate(cache.mainNav, {
        y: ['-100%', '0%'],
        duration: 1200,
        ease: cubicBezier(0.567, -0.013,0.493,0.98),
        onComplete: () => {
          cache.mainLinks.forEach(link => {
            const enterHandler = () => hoverLink(link);
            hoverHandlers.set(link, enterHandler);
            link.addEventListener("mouseenter", enterHandler);
            cache.btnOpenMenu.addEventListener("click", closeNav);
          });
        }
      });
    }

    let closeNav = () => {
      cache.btnOpenMenu.removeEventListener("click", closeNav);
      cache.header.classList.remove('nav_open');

      // Reset any link that was left in a hovered state (hover class + color class on mainNav)
      cache.mainLinks.forEach(link => {
        if (link.classList.contains('hover')) {
          link.classList.remove('hover');
          const color = link.getAttribute('data-color');
          if (color) cache.mainNav.classList.remove(color);
          const imgClass = link.getAttribute('data-img');
          const img = imgClass && cache.mainLinksBgContainer?.querySelector('.' + imgClass);
          if (img) animate(img, { opacity: 0, scale: 1.05, duration: 300 });
        }
      });

      animate(cache.mainLinkWrappers, {
          opacity: [1, 0],
          delay: stagger(50, { from: 'last' }),
          duration: 600,
          ease: cubicBezier(0.567, -0.013,0.493,0.98),
        });
      cache.mainLinks.forEach(link => {
        const enterHandler = hoverHandlers.get(link);
        if (enterHandler) {
          link.removeEventListener("mouseenter", enterHandler);
          hoverHandlers.delete(link);
        }
        const leaveHandler = leaveHandlers.get(link);
        if (leaveHandler) {
          link.removeEventListener("mouseleave", leaveHandler);
          leaveHandlers.delete(link);
        }
      });
      utils.enableScroll();
      cache.mainNavBg.classList.add('anime-init');
      animate(cache.mainNav, {
        y: ['0%', '-100%'],
        duration: 800,
        delay: 700,
        ease: cubicBezier(0.567, -0.013,0.493,0.98),
        onComplete: () => {
          cache.mainNav.style.display = "none";
          cache.btnOpenMenu.addEventListener("click", openNav);

          // Reset flags
          if (hasSticky) {
            cache.header.classList.remove('open_has-sticky');
            hasSticky = false;
          }

          // Re-query sections from the current page DOM (may have changed after AJAX navigation)
          refreshSections();

          // Determine the correct header colour from scratch based on scroll position + new sections
          updateNavColor();

          window.addEventListener('scroll', animeScroll);
          window.addEventListener('scroll', updateNavColor);
        }
      });
    }

    // Re-queries the page-specific sections after an AJAX content swap
    let refreshSections = () => {
      cache.darkSections = document.querySelectorAll('section.bg-dark, section.bg-dark-blue');
      cache.navWhiteSections = document.querySelectorAll('section.nav-white');
      cache.navDarkSections = document.querySelectorAll('section.nav-dark');
      cache.pageWrapper.style.marginBottom = cache.footer.offsetHeight + 'px';
    };

    let updateNavColor = () => {
      const headerHeight = cache.header.offsetHeight;
      const headerMid = window.pageYOffset + headerHeight / 2;

      const isOver = (sections) => {
        for (const section of sections) {
          const top = section.offsetTop;
          if (headerMid >= top && headerMid < top + section.offsetHeight) return true;
        }
        return false;
      };

      let isDark;
      if (isOver(cache.navWhiteSections)) {
        isDark = true;
      } else if (isOver(cache.navDarkSections)) {
        isDark = false;
      } else {
        isDark = isOver(cache.darkSections);
      }

      cache.header.classList.toggle('nav_white', isDark);
      cache.header.classList.toggle('nav_dark', !isDark);
    };

    let animeScroll = () => {
      let up = false;
      let trigger = 150;
      if(scrollPos > window.pageYOffset) {
        up = true;
      }
      scrollPos = window.pageYOffset;

      // Use cached footer height to avoid layout reflow on every scroll event.
      // Hysteresis: enter zone at footer threshold, exit only 40px above it
      // so iOS bounce oscillations don't rapidly toggle the nav.
      const maxScroll = document.documentElement.scrollHeight - window.innerHeight;
      const footerThreshold = maxScroll - cachedFooterHeight;
      const inFooter = inFooterZone
        ? scrollPos >= footerThreshold - 40
        : scrollPos >= footerThreshold;

      if (inFooter && globalVar) {
        inFooterZone = true;
        cache.header.classList.add('up');
        return;
      }

      // Just left the footer zone — reset flag and fall through to normal logic
      if (inFooterZone) {
        inFooterZone = false;
        if(!globalVar.desktop.matches) {
          cache.header.classList.remove('up');
        }
      }

      if(globalVar.desktop.matches) {
        if(scrollPos > trigger && !up && !cache.header.classList.contains('up') ) {
          if(!cache.header.classList.contains('open')) {
            cache.header.classList.add('up');
          }
        } else if(scrollPos > trigger && up && cache.header.classList.contains('up') ) {
          cache.header.classList.remove('up');
        }
      }
    }

    // Wraps animate() in a Promise that resolves when all targets finish
    let animP = (targets, props) => new Promise(res => {
      const arr = Array.isArray(targets) ? targets : [...targets];
      if (!arr.length) return res();
      animate(arr, { ...props, onComplete: res });
    });

    // Plays the nav-out animation for a page navigation triggered from within the nav.
    // Returns a Promise that resolves when the animation is done.
    let animateOutForNavigation = (clickedLinkEl) => {
      navNavigating = true;
      return new Promise((resolve) => {
        const isSecondary = !!clickedLinkEl?.closest('.nav-sec');

        if (isSecondary) {
          // Secondary link: fade other link wrappers to 0.3 + slide header up (background stays)
          const linkWrapper = clickedLinkEl?.closest('.main-nav-link');
          const otherWrappers = [...cache.mainLinkWrappers].filter(w => w !== linkWrapper);
          Promise.all([
            animP(otherWrappers, { opacity: 0.3, duration: 400 }),
            animP([cache.header], {
              y: '-100%',
              duration: 500,
              ease: cubicBezier(0.567, -0.013, 0.493, 0.98),
            }),
          ]).then(resolve);
          return;
        }

        // Primary nav link: stagger out everything else, slide header up, then center clicked link
        const linkWrapper = clickedLinkEl?.closest('.main-nav-link');
        const otherWrappers = [...cache.mainLinkWrappers].filter(w => w !== linkWrapper);
        const navSec = cache.mainNav.querySelector('.nav-sec');

        // Remove the mouseleave handler from the clicked link immediately so that
        // outLink() never fires as the element moves during the centering animation.
        // Also lock the background image at full opacity in case a fade was mid-flight.
        const leaveHandler = leaveHandlers.get(clickedLinkEl);
        if (leaveHandler) {
          clickedLinkEl.removeEventListener('mouseleave', leaveHandler);
          leaveHandlers.delete(clickedLinkEl);
        }
        const imgClass = clickedLinkEl?.getAttribute('data-img');
        const bgImg = imgClass ? cache.mainLinksBgContainer?.querySelector('.' + imgClass) : null;
        if (bgImg) animate(bgImg, { opacity: 1, scale: 1, duration: 0 });

        Promise.all([
          animP(otherWrappers, {
            opacity: [1, 0],
            delay: stagger(50, { from: 'last' }),
            duration: 500,
            ease: cubicBezier(0.567, -0.013, 0.493, 0.98),
          }),
          animP(navSec ? [navSec] : [], { opacity: 0, duration: 400 }),
          animP([cache.header], {
            y: '-100%',
            duration: 500,
            ease: cubicBezier(0.567, -0.013, 0.493, 0.98),
          }),
        ]).then(() => {
          if (!linkWrapper) return resolve();
          // Smoothly center the clicked link on screen
          const r = linkWrapper.getBoundingClientRect();
          const deltaY = window.innerHeight / 2 - (r.top + r.height / 2);
          return animP([linkWrapper], {
            y: [0, deltaY],
            duration: 700,
            ease: cubicBezier(0.567, -0.013, 0.493, 0.98),
          });
        }).then(resolve);
      });
    };

    // Instantly snaps the nav to its initial closed state — called while the page slide covers everything.
    let resetInstant = () => {
      navNavigating = false;
      // Snap nav closed without any animation
      cache.mainNav.style.display = 'none';
      cache.mainNav.style.opacity = '';
      cache.mainNavBg.classList.add('anime-init');
      cache.mainNavBg.style.opacity = '';

      // Clear all inline styles animejs set on link wrappers (opacity, transform)
      [...cache.mainLinkWrappers].forEach(w => {
        w.style.opacity = '';
        w.style.transform = '';
      });
      const navSec = cache.mainNav.querySelector('.nav-sec');
      if (navSec) navSec.style.opacity = '';

      // Reset all background images to their default hidden state
      cache.mainLinks.forEach(link => {
        const imgClass = link.getAttribute('data-img');
        const img = imgClass ? cache.mainLinksBgContainer?.querySelector('.' + imgClass) : null;
        if (img) { img.style.opacity = '0'; img.style.transform = ''; }
      });

      // Remove hover state and handlers
      cache.mainLinks.forEach(link => {
        link.classList.remove('hover');
        const color = link.getAttribute('data-color');
        if (color) cache.mainNav.classList.remove(color);
        const enterHandler = hoverHandlers.get(link);
        if (enterHandler) { link.removeEventListener('mouseenter', enterHandler); hoverHandlers.delete(link); }
        const leaveHandler = leaveHandlers.get(link);
        if (leaveHandler) { link.removeEventListener('mouseleave', leaveHandler); leaveHandlers.delete(link); }
      });

      // Reset header + flags — header is moved off-screen so slideHeaderIn can animate it in
      cache.header.classList.remove('nav_open', 'open_has-sticky');
      cache.header.style.transform = 'translateY(-100%)';
      hasSticky = false;

      // Restore the open-nav button listener
      cache.btnOpenMenu.removeEventListener('click', closeNav);
      cache.btnOpenMenu.addEventListener('click', openNav);

      // Re-query sections for the new page DOM
      refreshSections();

      // Keep scroll listeners off until slideHeaderIn re-enables them
      window.removeEventListener('scroll', animeScroll);
      window.removeEventListener('scroll', updateNavColor);
    };

    // Slides the header down from the top after `delay` ms, then restores normal scroll behaviour.
    let slideHeaderIn = (delay = 1000, onSlideComplete) => {
      setTimeout(() => {
        cache.header.classList.remove('up');
        animate(cache.header, {
          y: ['-100%', '0%'],
          duration: 800,
          ease: cubicBezier(0.567, -0.013, 0.493, 0.98),
          onComplete: () => {
            cache.header.style.transform = ''; // hand back control to CSS
            scrollPos = window.pageYOffset;    // sync so animeScroll starts clean
            updateNavColor();
            window.addEventListener('scroll', animeScroll);
            window.addEventListener('scroll', updateNavColor);
            if (typeof onSlideComplete === 'function') onSlideComplete();
          },
        });
      }, delay);
    };

    // Syncs internal scrollPos to the current position and updates nav colour
    // without running animeScroll — use after programmatic scrolls (e.g. anchor
    // on initial load) so the nav shows correctly without being hidden.
    let syncPosition = () => {
      scrollPos = window.pageYOffset;
      updateNavColor();
    };

    // Expose close so PageLoad can trigger it after a nav-link navigation
    window.__nav = { close: closeNav, refreshSections, animateOutForNavigation, resetInstant, slideHeaderIn, syncPosition };

    initFunc();
  };
}
export { Nav }
